import parser from 'html-react-parser';
import Topbar from '../../PulseSurvey/Topbar';
import React, { useEffect, useState } from 'react';
import { errorToast } from '../../../utils/helper';
import { PartnerApi } from '../../../api/partnerApi';
import Loader from '../../../component/common/Loader';

function PartnerLegals() {
  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);

  const getCmsData = () => {
    setLoader(true);
    PartnerApi.getCms(`partner-legals`)
      .then((res) => {
        if (res.data.meta.code === 1) {
          setLoader(false);
          setData(res.data.data);
        } else {
          setLoader(false);
          errorToast(res.data.meta.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <div className="relative lg:mb-[45px]">
      {loader ? <Loader /> : null}
      <Topbar title="Legals" />
      <div className="w-full overflow-hidden h-full lg:mt-8">
        <div className="col-span-3 relative h-full flex flex-col gap-y-4 hide-scrollbar overflow-y-auto">
          <div className="flex flex-col gap-3">
            {/* <span className="text-shoorah-newDashboardBlue dark:text-white md:text-3xl text-2xl md:font-bold font-semibold">
              Legals
            </span> */}
            <p className="P22Mackinac mx-auto dark:text-white text-[0.9rem] md:text-[1.2rem]">
              {data && data?.description && parser(data?.description)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerLegals;
